import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

const SuccessReservationPage = (props) => {

    const { t } = props

    return (
        <div>
		<header class="inner-pages subpages">
			<a onClick={() => props.goBack()} class="button-back"></a>
			<div class="heading align-center">
				<p class="bold">{t('resReservation.heading2')}</p>
			</div>
		</header>
		<section class="widgets">
			<div class="form-window">
				<div class="form-window-heading">{t('resReservation.success.confirmed')}</div>
				<div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1" style={{ borderColor: "#ccc" }}>
					<div class="form-row">
						<h2>{t('resReservation.success.thank_you')}</h2>
						<p style={{whiteSpace:"pre-line"}}>{t('resReservation.success.success_reser')}</p>
					</div>
				</div>
				<div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
					<div class="form-controls">
						<button class="primary w-100 margin-bottom-1" onClick={() => props.close()}>Close</button>
					</div>
				</div>
			</div>
		</section>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
    }
}

export default connect(mapStateToProps, { })(withTranslation('translations')(SuccessReservationPage));